import { t } from "ttag";

import {
  useSessionCategory,
  useSessionStatus,
} from "@/features/coaching/hooks";
import { SESSION_ICON_MAP } from "@/features/coaching/models";
import { EmptyState } from "@/shared/ui";

export const SessionsEmptyState = () => {
  const { category, categoryLabel } = useSessionCategory();
  const { statusLabel } = useSessionStatus();

  return (
    <EmptyState.Root className="justify-self-center border-transparent">
      <EmptyState.Icon>
        {category && SESSION_ICON_MAP[category]}
      </EmptyState.Icon>

      <EmptyState.Description>
        {category
          ? t`There are no ${statusLabel} ${categoryLabel} sessions yet`
          : t`There are no ${statusLabel} sessions yet`}
      </EmptyState.Description>
    </EmptyState.Root>
  );
};
